import { ThemeProvider } from "@mui/material/styles";
import React from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import AddDashboardUser from "./components/AddDashboardUser";
import AddMathlabUser from "./components/AddMathlabUser";
import DashboardUsers from "./components/DashboardUsers.jsx";
import IndvidualMathlabUsers from "./components/IndividualMathlabUsers.jsx";
import IndividualLayout from "./components/layout/IndividualLayout.jsx";
import MathlabLayout from "./components/layout/MathlabLayout";
import PrivateLayout from "./components/layout/PrivateLayout";
import SmartClassLayout from "./components/layout/SmartClassLayout";
import MathlabUsers from "./components/MathlabUsers.jsx";
import { UserContextProvider } from "./contexts/UserContext.tsx";
import { GlobalProvider } from "./contexts/GlobalContext.jsx";
import Block from "./pages/blocks/Block";
import Blocks from "./pages/blocks/Blocks";
import District from "./pages/districts/District.jsx";
import Districts from "./pages/districts/Districts";
import Home from "./pages/home/Home";
import { HomeLearning } from "./pages/homeLearning/HomeLearning.jsx";
import { IndividualStudentProgress } from "./pages/individualStudentProgress/IndividualStudentProgress.jsx";
import Login from "./pages/login/Login";
import { MonthlyReport } from "./pages/monthlyReport/MonthlyReport.jsx";
import { Report } from "./pages/report/Report.jsx";
import School from "./pages/schools/School";
import Schools from "./pages/schools/Schools";
import { Student } from "./pages/student/Student.jsx";
import { StudentExerciseProgress } from "./pages/studentExerciseProgress/StudentExerciseProgress.jsx";
import { StudentProgress } from "./pages/studentProgress/StudentProgress.jsx";
import { StudentProgressGrid } from "./pages/studentProgressGrid/StudentProgressGrid.jsx";
import SyncStatus from "./pages/syncstatus/SyncStatus";
import { Teacher } from "./pages/teacher/Teacher.jsx";
import theme from "./theme";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import TopStudents from "./pages/topstudents/TopStudents.jsx";
import SchoolReport from "./pages/SchoolReport.jsx";

const App = () => {
  console.log("Build Version - 07.07.2025 - Fixed null school_id error.");
  const client = new QueryClient();
  return (
    <QueryClientProvider client={client}>
      <ThemeProvider theme={theme}>
        <div className="app dark">
          <HashRouter basename="/">
            <UserContextProvider>
              <GlobalProvider>
                <Toaster richColors visibleToasts={1} duration={1500} />
                <Routes>
                  <Route path="login" element={<Login />} />
                  <Route path="report/:id" element={<Report />} />
                  <Route
                    path="school/:schoolID/report"
                    element={<SchoolReport />}
                  />
                  <Route path="/" element={<PrivateLayout />}>
                    <Route index element={<Home />} />
                    <Route path="district/:id" element={<District />} />
                    <Route path="district" element={<Districts />} />
                    <Route path="/homelearning" element={<HomeLearning />} />
                    <Route path="block/:id" element={<Block />} />
                    <Route path="blocks" element={<Blocks />} />
                    <Route path="school/:id" element={<School />} />
                    <Route path="school" element={<Schools />} />
                    <Route path="serverstatus" element={<SyncStatus />} />
                    <Route path="monthlyreport" element={<MonthlyReport />} />
                    <Route path="topstudents" element={<TopStudents />} />

                    {/* Student Routes */}
                    <Route path="student" element={<Student />} />
                    <Route
                      path="student/school/studentprogress/:id"
                      element={<StudentProgress />}
                    />
                    <Route
                      path="student/studentprogress/:course_id/:name/:id"
                      element={<IndividualStudentProgress />}
                    />
                    <Route
                      path="student/studentexerciseprogress/:id"
                      element={<StudentExerciseProgress />}
                    />
                    <Route
                      path="student/progressgrid/:id"
                      element={<StudentProgressGrid />}
                    />
                    {/* Teacher Routes */}
                    <Route path="teacher" element={<Teacher />} />

                    {/* Admin Routes */}
                    <Route path="mathlabUsers" element={<MathlabUsers />} />
                    <Route
                      path="add-mathlab-user"
                      element={<AddMathlabUser />}
                    />
                    <Route path="dashboardUsers" element={<DashboardUsers />} />
                    <Route
                      path="add-dashboard-user"
                      element={<AddDashboardUser />}
                    />
                  </Route>

                  {/* Routes with both smart_class and mathlab access */}
                  <Route
                    path="/dashboard/school/:id/"
                    element={<IndividualLayout />}
                  >
                    <Route index element={<School />} />
                    <Route
                      path="studentprogress"
                      element={<StudentProgress />}
                    />
                    <Route
                      path="studentexerciseprogress"
                      element={<StudentExerciseProgress />}
                    />
                    <Route
                      path="progressgrid"
                      element={<StudentProgressGrid />}
                    />
                    <Route
                      path="student/studentprogress/:course_id/:name/:sid"
                      element={<IndividualStudentProgress />}
                    />
                    <Route
                      path="mathlabUsers"
                      element={<IndvidualMathlabUsers />}
                    />
                    <Route
                      path="add-mathlab-user"
                      element={<AddMathlabUser />}
                    />
                  </Route>

                  {/* Route with smart_class access */}
                  <Route
                    path="/smartclass/school/:id"
                    element={<SmartClassLayout />}
                  >
                    <Route index element={<School />} />
                  </Route>

                  {/* Route with mathlab access */}
                  <Route path="/mathlab/school/:id" element={<MathlabLayout />}>
                    <Route index element={<StudentProgress />} />
                    <Route
                      path="studentexerciseprogress"
                      element={<StudentExerciseProgress />}
                    />
                    <Route
                      path="progressgrid"
                      element={<StudentProgressGrid />}
                    />
                    <Route
                      path="student/studentprogress/:course_id/:name/:sid"
                      element={<IndividualStudentProgress />}
                    />
                    <Route
                      path="mathlabUsers"
                      element={<IndvidualMathlabUsers />}
                    />
                    <Route
                      path="add-mathlab-user"
                      element={<AddMathlabUser />}
                    />
                  </Route>
                </Routes>
              </GlobalProvider>
            </UserContextProvider>
          </HashRouter>
        </div>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default App;
